import * as apis from './apis';

/**
 * Create api
 * @param {Function} request based on request instance
 */
const createApis = (request: apis.FetchType) => {
  const keys: KeyTypes = Object.keys(apis) as KeyTypes;

  const ret: any = {};
  keys.forEach((k) => {
    ret[k] = apis[k](request);
  });
  return ret as ApiTypes;
};

type KeyTypes = (keyof typeof apis)[];
type Apis<T> = T extends { [key: string]: (...args: any[]) => any }
  ? {
      [K in keyof T]: ReturnType<T[K]>;
    }
  : T;

export type ApiTypes = Apis<typeof apis>;

export default createApis;
